var _circle, _circle2, _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4,
    stroke: "#797F84",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 3,
    stroke: "#797F84",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.3284C0 16.8334 2.92058 14 6.52308 14H9.47692C13.0794 14 16 16.8334 16 20.3284V24H0V20.3284ZM1.96923 20.3284C1.96923 17.8885 4.00816 16 6.52308 16H9.47692C11.9918 16 14.0308 17.8885 14.0308 20.3284V22H1.96923V20.3284Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0308 22V24H16.0308V22H14.0308ZM1.96923 22H-0.0307692V24H1.96923V22ZM16 24V26H18V24H16ZM0 24H-2V26H0V24ZM6.52308 14C3.01583 14 -0.0307692 16.6749 -0.0307692 20.3284H3.96923C3.96923 19.1021 5.00048 18 6.52308 18V14ZM9.47692 14H6.52308V18H9.47692V14ZM16.0308 20.3284C16.0308 16.6749 12.9842 14 9.47692 14V18C10.9995 18 12.0308 19.1021 12.0308 20.3284H16.0308ZM16.0308 22V20.3284H12.0308V22H16.0308ZM1.96923 24H14.0308V20H1.96923V24ZM-0.0307692 20.3284V22H3.96923V20.3284H-0.0307692ZM2 20.3284C2 17.9947 3.96758 16 6.52308 16V12C1.87358 12 -2 15.6721 -2 20.3284H2ZM6.52308 16H9.47692V12H6.52308V16ZM9.47692 16C12.0324 16 14 17.9947 14 20.3284H18C18 15.6721 14.1264 12 9.47692 12V16ZM16 22H0V26H16V22ZM2 24V20.3284H-2V24H2ZM14 20.3284V24H18V20.3284H14Z",
    fill: "#797F84",
    mask: "url(#path-3-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 20V17.4299C24.0002 14.9834 21.8097 13 19.1079 13H16.8925C15.2207 13 13.7447 13.7593 12.8623 14.9179C13.4007 15.2356 13.888 15.6269 14.3093 16.0773C14.3244 16.051 14.3402 16.0253 14.3564 16C14.8019 15.3087 15.659 15 16.8925 15H19.1079C20.3413 15 21.1984 15.3087 21.6439 16C21.8797 16.3658 22.0002 16.8388 22.0002 17.4299V18H15.5445C15.7992 18.6241 15.9545 19.2969 15.9915 20H24.0002Z",
    fill: "#797F84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuUsers);
export default __webpack_public_path__ + "static/media/icon_menu_users.9edce0a2.svg";
export { ForwardRef as ReactComponent };